import React, { createContext, useEffect, useRef } from 'react';
import { FC, useMemo } from 'react';
import { observer } from 'mobx-react';
import { IUserCommunicationsChannelsWidgetProps, IUserCommunicationsChannelsWidgetRowProps } from './interfaces/IProps';
import { UserCommunicationsChannelsStore } from './store/UserCommunicationsChannels.store';
import { WidgetBase } from 'src/libs/ui-kit/widget-base/WidgetBase';
import { Checkbox } from 'src/libs/ui-kit/inputs/Checkbox/Checkbox';
import { useStore } from '../../hooks/useStore';
import { ChannelGroupsEnum, IChannel } from './interfaces';
import i18n from 'src/i18n';
import { WidgetTable } from 'src/libs/ui-kit/widget-table/WidgetTable';

const UserCommunicationsChannelsStoreContext = createContext<UserCommunicationsChannelsStore | null>(null);

export const UserCommunicationsChannels: FC<IUserCommunicationsChannelsWidgetProps> = observer(({ provider, col }) => {
  const store = useMemo(() => new UserCommunicationsChannelsStore(provider), [provider]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    store.loadPreferences();
  }, []);

  return (
    <UserCommunicationsChannelsStoreContext.Provider value={store}>
      <WidgetBase col={col} hasError={store.hasError} isLoading={store.isLoading} title="Каналы связи">
        <div className="px-5">
          <WidgetTable>
            <thead>
              <tr>
                <th className="border-0 text-tiny pt-0">Канал</th>
                <th className="border-0 text-tiny pt-0">Реклама</th>
              </tr>
            </thead>
            <tbody>
              {Array.from(store.channels.values()).map((ch) => (
                <Row channel={ch} />
              ))}
            </tbody>
          </WidgetTable>
        </div>
      </WidgetBase>
    </UserCommunicationsChannelsStoreContext.Provider>
  );
});

export const Row: FC<IUserCommunicationsChannelsWidgetRowProps> = observer(({ channel }) => {
  const store = useStore(UserCommunicationsChannelsStoreContext);

  return (
    <tr>
      <td>
        <div>{i18n.t(`channelName.${channel.name}`, { ns: 'channels' })}</div>
      </td>
      <td>
        <Checkbox
          name={channel.name + ChannelGroupsEnum.MARKETING}
          checked={channel.groups[ChannelGroupsEnum.MARKETING].isEnabled}
          onChange={() => store.onChangeCommunicationChannel(channel.name, ChannelGroupsEnum.MARKETING)}
        />
      </td>
    </tr>
  );
});
